<script>
import {
  mapGetters
} from 'vuex'
import * as Helper from '@/modules/helper/index'
export default {
  computed: {
    ...mapGetters([
      'MainMenuLayout',
      'MainMenuList',
      'MainMenu',
      'DesignSettings'
    ]),
    getAlignmentAndFont() {
      let align
      if (Helper.IsValid(this.MainMenu.MenuItemAlignment)) {
        switch (this.MainMenu.MenuItemAlignment) {
          case 1:
            align = { 'text-align': 'left', 'font-family': this.MainMenu.MenuItemFontName }
            break
          case 2:
            align = { 'text-align': 'center', 'font-family': this.MainMenu.MenuItemFontName }
            break
          case 3:
            align = { 'text-align': 'right', 'font-family': this.MainMenu.MenuItemFontName }
            break
          default:
            align = { 'text-align': 'right', 'font-family': this.MainMenu.MenuItemFontName }
        }
      }
      return align
    }
  },
  mounted(){
    console.log("MEnu ITem LIsrt =>", this.MainMenuList)
  },
  methods: {
    getItemStyle(backgroundColor) {
      if (Helper.IsValid(this.MainMenu.MenuItemFontColor)) {
        let hashCodefc = Helper.HashCodeFromInt(this.MainMenu.MenuItemFontColor)
        let hashCodebc = Helper.HashCodeFromInt(backgroundColor)
        let colorrgb = Helper.hexToRgb(hashCodebc)
        return {
          'color': hashCodefc,
          'background': 'rgba(' + colorrgb + ',' + this.MainMenu.MenuItemContainerOpacity + ')'
        }
      }
    }
  }
}
</script>
<template>
<div class="main-menu-list">
  <ul :style="getAlignmentAndFont" class="main-menu-list-ul">
    <li v-for="(MenuItem,index) in MainMenuList" v-if="index < 5" :key="index">
      <f7-link :href="`/${MenuItem.url}/${MenuItem.Id}`" :key="index" :style="getItemStyle(MenuItem.MenuIconColor)">
        {{MenuItem.MenuLabel}}
        <span v-if="MenuItem.UnreadChatMessageCount && MenuItem.UnreadChatMessageCount > 0" 
              class="badge">{{MenuItem.UnreadChatMessageCount}}</span>
      </f7-link>
    </li>
    <li v-if="MainMenuList.length === 6">
      <f7-link :href="`/${MainMenuList[5].url}/${MainMenuList[5].Id}`" :style="getItemStyle(MainMenuList[5].MenuIconColor)">
        {{MainMenuList[5].MenuLabel}}
        <span v-if="MainMenuList[5].UnreadChatMessageCount && MainMenuList[5].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[5].UnreadChatMessageCount}}</span>
      </f7-link>
    </li>
    <li class="item-content" v-if="MainMenuList.length > 6">
      <f7-link popup-open="#more-popup" :style="getItemStyle(MainMenu.MenuItemOverflowBackgroundColor)">{{MainMenu.MenuItemOverflowLabel}}</f7-link>
    </li>
  </ul>
</div>
</template>
<style scoped>
  .device-iphone-x .main-menu-list-ul {
    margin: 10px 0px 25px;
  }
  /* .badge{
    min-width: 16px!important;
    height: 16px;
    position: absolute;
    top: 2px;
    right: 2px;
    line-height: 16px;
    padding: 0 5px;
    font-size: 10px;
    margin: 0!important;
    max-width: 40px;
  } */
</style>


// WEBPACK FOOTER //
// src/components/shared/menu-layout/ListMenu.vue